<nav
  id="mainHeader"
  class="navbar navbar-light px-0 px-md-4 w-100 py-1 py-md-2 justify-content-between"
  [class.is-admin]="!mainMenu()[4].hidden"
>
  <a
    class="navbar-brand ps-4 ps-md-0 logo"
    [routerLink]="['/courses', 'my-courses']"
  >
    <img
      src="https://media.mirasee.com/images/logo/logo.png"
      alt="Mirasee"
      class="img-fluid"
      fetchpriority="high"
    />
  </a>
  <div class="bg-white mobile-menu">
    <nb-menu
      [items]="mainMenu()"
      tag="mainmenu"
      class="mx-auto float-start inline-menu"
    ></nb-menu>
  </div>
  <nb-actions class="navbar-profile" size="small">
    <nb-action class="user-action pe-4 pe-md-0">
      <nb-user
        [nbContextMenu]="userMenu"
        nbContextMenuTag="profile-menu"
        [name]="user().firstname"
        [picture]="user().avatar"
        [onlyPicture]="true"
      ></nb-user>
    </nb-action>
  </nb-actions>
</nav>
